import styled from 'styled-components';

export interface IProps {
	color?: string;
}

export default styled.p<IProps>`
	font-size: 16px;
	line-height: 1.35;
	margin-bottom: 0;
	word-break: break-word;

	${(props) =>
		props.color
			? `
		color: ${props.theme.colors[props.color]};
	`
			: ''}

	a {
		color: ${(props) => props.theme.colors.primary};
		text-decoration: underline;

		&:hover {
			color: ${(props) => props.theme.colors.primary};
		}
	}
`;

export const ParagraphSmall = styled.p<IProps>`
	font-size: 14px;
	margin-bottom: 0;

	${(props) =>
		props.color
			? `
	color: ${props.theme.colors[props.color]};
`
			: ''}
`;
